import { PRIVATE, EVERYONE, SPECIFIC } from 'sales-content-partitioning/constants/SharingOptionTypes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SharingRadioInput from './SharingRadioInput';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const I18N_MAP = {
  TEMPLATE: {
    one: `salesContentPartitioning.assignmentPanel.message.template`,
    many: `salesContentPartitioning.assignmentPanel.message.templates`
  },
  SEQUENCE: {
    one: `salesContentPartitioning.assignmentPanel.message.sequence`,
    many: `salesContentPartitioning.assignmentPanel.message.sequences`
  },
  DOCUMENT: {
    one: `salesContentPartitioning.assignmentPanel.message.document`,
    many: `salesContentPartitioning.assignmentPanel.message.documents`
  },
  PLAYBOOK: {
    one: `salesContentPartitioning.assignmentPanel.message.playbook`,
    many: `salesContentPartitioning.assignmentPanel.message.playbooks`
  }
};
const AssignmentPanelOptions = ({
  objectType,
  sharingOption,
  canAssignContent,
  handleSharingOptionChange,
  isBulkEdit = false
}) => {
  const messageObject = I18N_MAP[objectType];
  const message = isBulkEdit ? messageObject.many : messageObject.one;
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: message
    }),
    required: false,
    children: /*#__PURE__*/_jsxs(ToggleGroup, {
      name: "sharingOptions",
      children: [/*#__PURE__*/_jsx(SharingRadioInput, {
        option: PRIVATE,
        selectedValue: sharingOption,
        onChange: handleSharingOptionChange
      }), /*#__PURE__*/_jsx(SharingRadioInput, {
        option: EVERYONE,
        selectedValue: sharingOption,
        onChange: handleSharingOptionChange
      }), /*#__PURE__*/_jsx(SharingRadioInput, {
        option: SPECIFIC,
        selectedValue: sharingOption,
        onChange: handleSharingOptionChange,
        readOnly: !canAssignContent,
        showLock: !canAssignContent
      })]
    })
  });
};
export default AssignmentPanelOptions;